import { amplitudeTrack } from '@cw-elements/analytics-provider';

type AnalyticsStatus = 'disabled' | 'initializing' | 'ready';

let status: AnalyticsStatus = 'disabled';
const listeners = new Set<() => void>();
let pendingEvents: Array<{ name: string; properties: Record<string, unknown> }> = [];

export function subscribeAnalyticsReady(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function isAnalyticsReady() {
  return status === 'ready';
}

export function setAnalyticsStatus(nextStatus: AnalyticsStatus) {
  status = nextStatus;
  listeners.forEach((listener) => listener());
  const events = pendingEvents;
  pendingEvents = [];
  if (status === 'ready') {
    events.forEach(({ name, properties }) => amplitudeTrack(name, properties));
  }
}

export function clearPendingAnalyticsEvents() {
  pendingEvents = [];
}

export function trackAnalyticsEvent(name: string, properties: Record<string, unknown>) {
  if (status === 'initializing') {
    // Snapshot at capture time: startup events must not acquire a later route's context.
    pendingEvents.push({ name, properties: { ...properties } });
    return;
  }
  if (status === 'ready') {
    return amplitudeTrack(name, properties);
  }
}
